import { useEffect, useRef } from 'react';
import { normalizeChartType, RENDERABLE_CHART_TYPES } from 'constants/appConstants';

interface QueryValidityArgs {
  rawType: string;
  /** The Data tab's query text. */
  queries: string;
  /** Whether the editor currently flags the query as invalid. */
  invalidQuery: boolean;
  onValid: () => void;
  onInvalid: () => void;
}

/** Tells the editor when the query text becomes (in)valid JSON. Types that never read the query are always valid. */
export function useQueryValidity({ rawType, queries, invalidQuery, onValid, onInvalid }: QueryValidityArgs): void {
  const callbacks = useRef({ onValid, onInvalid });
  callbacks.current = { onValid, onInvalid };

  useEffect(() => {
    if (!rawType) return;
    if (!RENDERABLE_CHART_TYPES.includes(normalizeChartType(rawType))) {
      if (invalidQuery) callbacks.current.onValid();
      return;
    }
    try {
      const parsed: unknown = JSON.parse(queries);
      if (!parsed || typeof parsed !== 'object') return;
      if (invalidQuery) callbacks.current.onValid();
    } catch {
      if (!invalidQuery) callbacks.current.onInvalid();
    }
  }, [rawType, queries, invalidQuery]);
}
